import React, { startTransition } from 'react';
import TxtSTViewerClass from './txtSTViewerclass';
import PreviewBase from './previewbase';


class PreviewTXTST extends PreviewBase
{


constructor (props)
{
    super(props);
    this.state.renderedCode = "";
    this.state.isPending = false;
    this.olddatas = "";

}



componentDidMount()
{
    super.componentDidMount();
    this.deferRender(this.state.datas);


}                                                                                    
componentDidUpdate()
{
    super.componentDidUpdate();

    if (this.olddatas !== this.state.datas)
    {
        this.olddatas = this.state.datas;
        this.deferRender(this.state.datas);
    }
}

componentWillUnmount()
{
    super.componentWillUnmount();
}

deferRender(code) {
    this.setState({ isPending: true });
    
    startTransition(() => {
        
      this.setState({ renderedCode: code, isPending: false });
    });
  }


setFile(datas)
{
    this.setState({datas: datas})
}



render()
{
    const { renderedCode, isPending } = this.state;
    // before : <TextWithBreaks text={renderedCode}/>
    if (isPending)
        return (<p>Chargement du code…</p>)
    else
        if (renderedCode)
            return(<div className='preview_div_srt'><TxtSTViewerClass text={renderedCode} /></div>)
        else
            return (<></>)
    


    

}

}
export default PreviewTXTST;

